import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import CatService from "../../service/CatService";
import { DataTable } from "primereact/datatable";
import { useTranslation } from "react-i18next";
import CmsService from "../../service/CmsService";
import { Button } from "primereact/button";

export function QueLogs({id})
{
    const {t}=useTranslation();
    const [logs,setLogs]=useState([]);
    
    useEffect(()=>{
        if(id==undefined || id==0)
            return;
        console.log('QUE_LOGS');
        CmsService.getQuestionLogs(id).then((ret)=>{
            setLogs(ret);
        });
    },[id]);
    return(
        <LogGrid logs={logs}/>
    )
}
export function LogGrid({logs})
{
    const {t}=useTranslation();
    const [expandedRows,setExpandedRows]=useState([]);

    const expandRow=(data)=>{
        let _expandedRows = [data];
        setExpandedRows(_expandedRows);
    }
    const collapseRow=(data)=>{
        let _expandedRows = expandedRows.filter((item)=>{return item.id!=data.id});
        setExpandedRows(_expandedRows);
    }
    const toggleRow=(data)=>{
        var expanded=false;
        expandedRows.forEach((item)=>{
            if(item.id==data.id)
                expanded=true;
        });
        if(expanded)
            collapseRow(data);
        else
            expandRow(data);
    }
    const onRowCollapse=(log)=>{
        setExpandedRows([]);
    }
    const rowExpansionTemplate = (log) => {
        return (
            <div className="p-3">{log.dat}</div>
        );
    };    
    const expanderTemplate=(log)=>{
        if(log.dat==null)
            return '';
        return <Button size="small" outlined severity="primary" onClick={()=>toggleRow(log)}>{t('Detail')}</Button>;
    }
    return(
        <div className="grid m-0 mt-2">
            <DataTable value={logs} dataKey="id" showGridlines className="p-datatable-striped p-datatable-sm w-full"
                expandedRows={expandedRows} rowExpansionTemplate={rowExpansionTemplate}>
                <Column field="id" header={t("Id")} style={{width:'10%'}} sortable></Column>
                <Column field="actDate" header={t("Datetime")} style={{width:'20%'}} 
                    body={(log)=>t('datetime.short',{val:log.actDate})} sortable></Column>
                <Column field="userName" header={t("User")} style={{width:'20%'}} sortable></Column>
                <Column field="action" header={t("Action")} style={{width:'20%'}} sortable></Column>
                <Column field="path" header={t("Path")} style={{width:'20%'}} sortable></Column>
                <Column body={expanderTemplate}/>
            </DataTable>
        </div>
    )
}
